import { createClient } from 'contentful';

const client = createClient({
  space: 'loo96t35ahr2',
  accessToken: 'RBQ63gWkpb7CZN2F1k_XGfPnZkfpWH8ZKzovDsoy37c',
});

export default client;
